import { render, staticRenderFns } from "./ProductsDetail.vue?vue&type=template&id=28b940fe&scoped=true"
import script from "./ProductsDetail.vue?vue&type=script&lang=js"
export * from "./ProductsDetail.vue?vue&type=script&lang=js"
import style0 from "./ProductsDetail.vue?vue&type=style&index=0&id=28b940fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b940fe",
  null
  
)

export default component.exports